import { v4 as uuidv4 } from 'uuid';
import {
  Criterion,
  CriterionBehavior,
  CriterionListItem,
  FieldChoice,
  ListValueType,
  SelectionBehavior,
} from 'queries';
import { ICriterionHandler } from './ICriterionHandler';
import { ParticipantField, ParticipantFieldType } from '@app/api';

export class LocationCriterionHandler extends ICriterionHandler {
  handleCriterion(criterion: Criterion) {
    return criterion.listValueType === ListValueType.LOCATION;
  }

  criterionHandleOthers() {
    return false;
  }

  handleParticipantField(field: ParticipantField): boolean {
    return field.type === ParticipantFieldType.GEOLOCATION;
  }

  createEmptyCriterionFromParticipantField(field: ParticipantField): Criterion {
    return {
      id: uuidv4(),
      fieldRef: field.name,
      screenerCriterion: false,
      selectionBehavior: SelectionBehavior.NO_SELECTION,
      listValueType: ListValueType.LOCATION,
      allowList: null,
      denyList: [],
    };
  }

  setCriterionValues(
    criterion: Criterion,
    values?: CriterionListItem[],
    choices?: FieldChoice[],
  ): Criterion {
    if (!values) {
      return {
        ...criterion,
        allowList: null,
        denyList: [],
      };
    }

    return {
      ...criterion,
      allowList: values,
      denyList: [],
    };
  }

  protected compareValues(item: CriterionListItem, choice: FieldChoice) {
    if (typeof item === 'object' && !('location' in item)) {
      return false;
    }

    return super.compareValues(item, choice);
  }
}
